export default __webpack_public_path__ + "static/media/canopy.75c9a088.jpg";